import { render, staticRenderFns } from "./FormErrors.vue?vue&type=template&id=33413cbc&scoped=true&"
import script from "./FormErrors.vue?vue&type=script&lang=ts&"
export * from "./FormErrors.vue?vue&type=script&lang=ts&"
import style0 from "./FormErrors.vue?vue&type=style&index=0&id=33413cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33413cbc",
  null
  
)

export default component.exports